import { YES, YES_NO } from "../assessment-constant";
import { FreeTextScreenerDef } from "../assessment-types";

const TOBACCO_GROUPS = {
  treatment: "Treatment Plan",
  attestation: "Clinician Attestation",
} as const;

const TOBACCO_PLACEHOLDERS = {
  amountUsed: "e.g., 10 cigarettes/day",
  durationOfUse: "e.g., 5 years",
  followUpTimeframe: "e.g., 2 weeks",
} as const;

const yesNo = (questionId: number, questionText: string, group?: string) =>
  ({
    questionId,
    questionText,
    group,
    kind: "yesNo",
    audience: "PATIENT",
    options: YES_NO,
  }) as const;

export const TOBACCO_SCREENER: FreeTextScreenerDef = {
  questions: [
    yesNo(1, "Current tobacco user?", undefined),
    {
      questionId: 2,
      questionText: "Type",
      group: undefined,
      kind: "multi",
      audience: "PATIENT",
      options: [
        "Cigarettes",
        "Cigars",
        "Smokeless tobacco",
        "Vaping/e-cigarette nicotine",
        "Other",
      ],
    },
    {
      questionId: 3,
      questionText: "Amount used",
      group: undefined,
      kind: "text",
      audience: "PATIENT",
      placeholder: TOBACCO_PLACEHOLDERS.amountUsed,
    },
    {
      questionId: 4,
      questionText: "Duration of use",
      group: undefined,
      kind: "text",
      audience: "PATIENT",
      placeholder: TOBACCO_PLACEHOLDERS.durationOfUse,
    },
    yesNo(5, "Former smoker?", undefined),
    {
      questionId: 6,
      questionText: "Quit date",
      label: "Quit date if former",
      group: undefined,
      kind: "date",
      audience: "PATIENT",
      dateRule: "notFuture",
      showIf: [{ questionId: 5, equals: YES }],
    },
    yesNo(7, "Tobacco use reviewed today", undefined),
    yesNo(8, "Tobacco-related symptoms or disease discussed", undefined),
    yesNo(9, "Dependence / use disorder concerns", undefined),
    {
      questionId: 14,
      questionText: "Motivation to quit",
      group: undefined,
      kind: "single",
      audience: "PATIENT",
      options: [
        "Not ready",
        "Considering quitting",
        "Ready to quit",
        "Actively quitting",
      ],
    },
    yesNo(10, "Risks of continued tobacco use discussed", undefined),
    yesNo(11, "Benefits of cessation discussed", undefined),
    yesNo(12, "Personalized quit advice provided", undefined),
    yesNo(13, "Barriers to quitting discussed", undefined),
    {
      questionId: 15,
      questionText: "Behavioral strategies reviewed",
      group: undefined,
      kind: "multi",
      audience: "PATIENT",
      options: [
        "Set quit date",
        "Trigger avoidance",
        "Stress coping",
        "Support system",
        "Relapse prevention",
        "Other",
      ],
    },
    yesNo(16, "Quit date selected", TOBACCO_GROUPS.treatment),
    {
      questionId: 17,
      questionText: "Target quit date",
      group: TOBACCO_GROUPS.treatment,
      kind: "date",
      audience: "PATIENT",
      dateRule: "notPast",
      showIf: [{ questionId: 16, equals: YES }],
    },
    {
      questionId: 18,
      questionText: "Medication discussed or prescribed",
      group: TOBACCO_GROUPS.treatment,
      kind: "multi",
      audience: "PATIENT",
      options: [
        "Nicotine replacement therapy",
        "Bupropion",
        "Varenicline",
        "None",
        "Other",
      ],
      exclusiveOption: "None",
    },
    {
      questionId: 19,
      questionText: "Referral or resources provided",
      group: TOBACCO_GROUPS.treatment,
      kind: "multi",
      audience: "PATIENT",
      options: [
        "Quitline",
        "Printed handout",
        "Behavioral health",
        "Group counseling",
        "Other",
      ],
    },
    {
      questionId: 20,
      questionText: "Time and billing",
      group: TOBACCO_GROUPS.treatment,
      kind: "single",
      audience: "PATIENT",
      options: ["99406 (>3 to 10 min)", "99407 (>10 min)"],
    },
    yesNo(21, "Follow-up planned", TOBACCO_GROUPS.treatment),
    {
      questionId: 22,
      questionText: "Follow-up timeframe",
      group: TOBACCO_GROUPS.treatment,
      kind: "text",
      audience: "PATIENT",
      placeholder: TOBACCO_PLACEHOLDERS.followUpTimeframe,
    },
    yesNo(23, "Patient understanding confirmed", TOBACCO_GROUPS.treatment),
    {
      questionId: 24,
      questionText: "Clinician attestation",
      group: TOBACCO_GROUPS.attestation,
      kind: "confirm",
      audience: "PATIENT",
      statement:
        "Patient is a current tobacco user. Tobacco use status was reviewed today.",
    },
  ],
};
